import { isMiniProgram } from '@/utils/index'

export const APP_TOP_NAV_HEIGHT = 44

function isLocalhostHost() {
  return /localhost/i.test(window.location.host)
}

export function isAppTopNavVisible(route) {
  if (!isMiniProgram()) return false
  // if (!isMiniProgram() && !isLocalhostHost()) return false
  const path = (route?.path || window.location.pathname).replace(/\/+$/, '') || '/'
  return path !== '/crm'
}

export function getAppViewportHeight(route) {
  return isAppTopNavVisible(route)
    ? `calc(100vh - ${APP_TOP_NAV_HEIGHT}px)`
    : '100vh'
}
